import React from "react";
import ProductsCarousel from "./Columns/ProductsCarousel";
import LazyLoad from "react-lazyload";
import RecentlyViewed from "./RecentlyViewed";
import SellBanner from "./Columns/SellBanner";
import {bindActionCreators} from "redux";
import {getCustomProductByHandle} from "../actionCreators/pdpAC";
import connect from "react-redux/es/connect/connect";
import Image from "react-bootstrap/Image";
import config from "../../config";
import Button from "react-bootstrap/Button";

class PdpSliders extends React.Component{
    constructor(props){
        super();

        this.state = {
            width: window.innerWidth,
            height: window.innerHeight,
            lazyLoad: true,
            lazy_offset: 500,
            last_changed: null
        };
    }

    render() {
        const {mobile_big, others_recommendation_items, similar_recommendation_items} = this.props;

        return(
            <>
                <div className="products-carousel__slider-container">
                    <LazyLoad height={500} offset={300}>
                        <ProductsCarousel
                            title="Similar Items"
                            alt_prefix="Similar Items: "
                            products={similar_recommendation_items}
                            products_total={similar_recommendation_items && similar_recommendation_items.length}
                            custom_class="products-carousel__similar-styles"
                        />
                    </LazyLoad>
                </div>
                <div className="products-carousel__slider-container">
                    <LazyLoad height={500} offset={300}>
                        <ProductsCarousel
                            title="Others You May Like"
                            alt_prefix="Others You May Like: "
                            products={others_recommendation_items}
                            products_total={others_recommendation_items && others_recommendation_items.length}
                            custom_class="products-carousel__find-another"
                        />
                    </LazyLoad>
                </div>
                <div className="products-carousel__slider-container">
                    <LazyLoad height={500} offset={300}>
                        <RecentlyViewed />
                    </LazyLoad>
                </div>
            </>
        )
    }
}

const mapStateToProps = function (state) {
    const {others_recommendation_items, similar_recommendation_items} = state.shopifyReducer;
    const {mobile_big } = state.appReducer;
    return {mobile_big, others_recommendation_items, similar_recommendation_items};
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        getCustomProductByHandle,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PdpSliders);